(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lds-product-variant-type-button"] && !Shopify.designMode) return;
  try {
    /* LDS Ajout. Séléction d'un pack par défaut */
(function() {
  function initDefaultPackRadios(root) {
    var radios = root.querySelectorAll('input.lds-quantity-input[type="radio"][data-default-pack]');
    if (!radios.length) return;

    var urlParams = new URLSearchParams(window.location.search);
    var urlHasVariant = urlParams.has('variant');

    var groupsByName = {};

    radios.forEach(function(input) {
      var name = input.name;
      if (!name) return;
      if (!groupsByName[name]) {
        groupsByName[name] = [];
      }
      groupsByName[name].push(input);
    });

    Object.keys(groupsByName).forEach(function(name) {
      var inputs = groupsByName[name];

      var defaultInput = inputs.find(function(input) {
        return input.dataset.defaultPack === 'true';
      });

      if (!defaultInput) return;

      if (urlHasVariant && inputs.some(function(input) { return input.checked; })) {
        return;
      }

      if (!defaultInput.checked) {
        defaultInput.checked = true;
        defaultInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initDefaultPackRadios(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.target) return;
    initDefaultPackRadios(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
